import Cookies from "js-cookie";

export default function () {
    const valuesMap = {};
    const cookies = [
        {
            'fieldName': 'utmcampaignft', 'cookieName': '__ft_utm_campaign'
        }, {
            'fieldName': 'utmsourceft', 'cookieName': '__ft_utm_source'
        }, {
            'fieldName': 'utmmediumft', 'cookieName': '__ft_utm_medium'
        }, {
            'fieldName': 'utmcontentft', 'cookieName': '__ft_utm_content'
        }, {
            'fieldName': 'utmtermft', 'cookieName': '__ft_utm_term'
        }, {
            'fieldName': 'googleidft', 'cookieName': '__ft_mgcid'
        }, {
            'fieldName': 'referrerft', 'cookieName': '__ft_referrer'
        }, {
            'fieldName': 'youtubeidft', 'cookieName': '__ft_youtube_id'
        }, {
            'fieldName': 'utmcampaignlt', 'cookieName': '__lt_utm_campaign'
        }, {
            'fieldName': 'utmsourcelt', 'cookieName': '__lt_utm_source'
        }, {
            'fieldName': 'utmmediumlt', 'cookieName': '__lt_utm_medium'
        }, {
            'fieldName': 'utmcontentlt', 'cookieName': '__lt_utm_content'
        }, {
            'fieldName': 'utmtermlt', 'cookieName': '__lt_utm_term'
        }, {
            'fieldName': 'googleidlt', 'cookieName': '__lt_mgcid'
        }, {
            'fieldName': 'referrerlt', 'cookieName': '__lt_referrer'
        }, {
            'fieldName': 'youtubeidlt', 'cookieName': '__lt_youtube_id'
        }
    ];

    cookies.forEach(cookie => {
        let cookieValue = Cookies.get(cookie.cookieName);

        valuesMap[cookie.fieldName] = cookieValue ? cookieValue : "not-set";
    });

    return valuesMap;
}